const FEATURE_FLAGS = {
  SPOTIFY_VIDEO_PODCAST_ENABLED: 'spotifyVideoPodcastEnabled',
  STREAMING_AD_INSERTION_ENABLED: 'streamingAdInsertionEnabled',
};

export type FeatureFlag =
  | typeof FEATURE_FLAGS.SPOTIFY_VIDEO_PODCAST_ENABLED
  | typeof FEATURE_FLAGS.STREAMING_AD_INSERTION_ENABLED;

function getIsSaiOrVodcast(featureFlags?: FeatureFlag[]) {
  return featureFlags
    ? featureFlags.includes(FEATURE_FLAGS.SPOTIFY_VIDEO_PODCAST_ENABLED) ||
        featureFlags.includes(FEATURE_FLAGS.STREAMING_AD_INSERTION_ENABLED)
    : false;
}

export { getIsSaiOrVodcast, FEATURE_FLAGS };
